/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_UnsavedInputs */

const vi_grower_area_qr_unsaved = /** @type {(inputs: Grower_Area_Qr_UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng chưa lưu nên chưa có mã QR. Vui lòng lưu hộ trồng trước.`)
};

/**

* @param {Grower_Area_Qr_UnsavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_unsaved = /** @type {((inputs?: Grower_Area_Qr_UnsavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_UnsavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_unsaved(inputs)
});